// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__3QmGC","slick-next":"CustomSlider_slick-next__m15zV"};